module.exports = __webpack_public_path__ + "img/hasSettled.244b60dc.png";